import { Alert } from '@festina-life/ui/feedback'
import { Stack } from '@festina-life/ui/structure'
import { cloneElement, type ReactElement } from 'react'

import { ManageHeader } from '../manageHeader/ManageHeader'

type ManageOption = {
  label: string
  description: string
  button: ReactElement
}

type Props = {
  title: string
  options: ManageOption[]
}

export const ManageSection = ({ title, options }: Props) => (
  <div className="flex flex-col w-full">
    <ManageHeader title={title}>
      <Alert severity="info" variant="mini">
        <Stack as="ul" className="flex-col">
          {options.map(({ label, description }) => (
            <li key={label}>
              <span className="font-semibold">{`${label}: `}</span>
              <span>{description}</span>
            </li>
          ))}
        </Stack>
      </Alert>
    </ManageHeader>
    <Stack className="flex flex-wrap w-full">
      {options.map(({ label, button }) => cloneElement(button, { key: label }))}
    </Stack>
  </div>
)
